//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PropsMixin          from './mixins/props.mixin';
import ComponentMixin      from './mixins/component.mixin';
import { library }         from '@fortawesome/fontawesome-svg-core';
import {
    faPlus,
    faMinus,
    faTimes
}                          from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add ( faPlus );
library.add ( faMinus );
library.add ( faTimes );

export default {

    // Module/component name
    name: 'VueGridDesigner',

    mixins: [
        PropsMixin,
        ComponentMixin
    ],

    components: {
        FontAwesomeIcon
    }

};
